import { useParams, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryTabs from './components/CategoryTabs';
import ArticleList from './components/ArticleList';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'compliance';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentSlug]);

  const currentCategory = categories.find((c) => c.slug === currentSlug);
  const categoryName = currentCategory?.name || '文章分类';
  const filteredArticles = articles.filter((a) => a.category === currentSlug);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '文章分类', path: '/category/compliance' },
              { name: categoryName },
            ]}
          />

          <div className="mb-6">
            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
              {categoryName}
            </h1>
            <p className="text-sm text-foreground-600">
              {currentCategory?.description}
            </p>
          </div>

          <CategoryTabs activeSlug={currentSlug} />

          <section className="py-8">
            <ArticleList articles={filteredArticles} />
          </section>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}